import { Token } from '@pancakeswap/sdk'
import JSBI from 'jsbi'

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt(
    '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
  )
}

export const ZERO_HEX = '0x0'

// export { ChainId } from '@traderjoe-xyz/sdk'

export enum ChainId {
  FANTOM = 250,
  FANTOM_TESTNET = 4002,
  FUJI = 43113,
  AVALANCHE = 43114,
  OPTIMISM_GOERLI = 420,
  OPTIMISM = 10,
  EOS = 17777,
  POLYGON_ZKEVM_TESTNET = 1442,
  POLYGON_ZKEVM = 1101,
  ARBITRUM_ONE = 42161
}

export const WAVAX = {
  [ChainId.FUJI]: new Token(ChainId.FUJI as any,'0xd00ae08403B9bbb9124bB305C09058E32C39A48c',18,'WAVAX','Wrapped AVAX'),
  [ChainId.AVALANCHE]: new Token(ChainId.AVALANCHE as any ,'0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',18,'WAVAX','Wrapped AVAX'),
  [ChainId.FANTOM_TESTNET]: new Token(ChainId.FANTOM_TESTNET as any, "0x5A5c0C4832828FF878CE3ab4fEc44d21200b1496", 18, 'WETH', 'Wrapped Fantom'),
  [ChainId.FANTOM]: new Token(ChainId.FANTOM as any, "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83", 18, 'WETH', 'Wrapped Fantom'),
  [ChainId.OPTIMISM_GOERLI]: new Token(ChainId.OPTIMISM_GOERLI as any, "0xb9b5D39eC0a9996Ec0d92f2fcF6C8B51A51B2d57", 18, 'WETH', 'Wrapped Ether'),
  [ChainId.OPTIMISM]: new Token(ChainId.OPTIMISM as any, "0x4200000000000000000000000000000000000006", 18, 'WETH', 'Wrapped Ether'),
  [ChainId.EOS]: new Token(ChainId.EOS as any, "0xc00592aA41D32D137dC480d9f6d0Df19b860104F", 18, 'WEOS', 'Wrapped EOS'),
  [ChainId.POLYGON_ZKEVM_TESTNET]: new Token(ChainId.POLYGON_ZKEVM_TESTNET as any, "0x4671AcA0C1fe99fE6779606698E61783d4520a41", 18, 'WETH', 'Wrapped Ether'),
  [ChainId.POLYGON_ZKEVM]: new Token(ChainId.POLYGON_ZKEVM as any, "0x4F9A0e7FD2Bf6067db6994CF12E4495Df938E6e9", 18, 'WETH', 'Wrapped Ether'),
  [ChainId.ARBITRUM_ONE]: new Token(ChainId.ARBITRUM_ONE as any, "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1", 18, 'WETH', 'Wrapped Ether'),
}